import React from "react";
import { CheckIcon } from "../Icons";

/** A short confirmation shown above the bottom navigation. */
const Toast = ({ message, bottom = 112 }) =>
  message ? (
    <div
      role="status"
      className="fixed inset-x-5 z-50 px-4 py-3.5 rounded-lg bg-cocoa text-white text-sm font-medium flex items-center gap-2.5 shadow-toast animate-slide-up"
      style={{ bottom }}
    >
      <CheckIcon size={20} />
      {message}
    </div>
  ) : null;

export default Toast;
